import { render, staticRenderFns } from "./Branded.vue?vue&type=template&id=73e890ae&scoped=true"
import script from "./Branded.vue?vue&type=script&lang=js"
export * from "./Branded.vue?vue&type=script&lang=js"
import style0 from "./Branded.vue?vue&type=style&index=0&id=73e890ae&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e890ae",
  null
  
)

export default component.exports